import React, { useState } from "react";
import "./Contactus.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Spinner from "./Spinner";
import Crew1 from "./iSW Banner 1.png";
import Crew2 from "./iSW Banner 2.png";
import Crew3 from "./iSW Banner 3.png";
import Crew4 from "./iSW Banner 4.png";
const crewImages = [Crew1, Crew2, Crew3, Crew4];

function ContactUs() {
  const navigate = useNavigate();
  const [emailSent, setEmailSent] = useState(false); // New state variable
  const [isLoading, setIsLoading] = useState(false);
  
  //Rotating crew image index and fade state
  const currentIndex = Math.floor(Math.random() * 4);
  const navigateTo = (path) => {
    navigate(path);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const data = {
      name: formData.get("name"),
      email: formData.get("email"),
      message: formData.get("message"),
    };

    try {
      await axios.post("https://fluency.ispeakwell.ca/api/send-email", data);
      setEmailSent(true); // Set emailSent to true on successful email sending
    } catch (error) {
      console.error("Error sending email:", error);
      // Handle errors here, such as displaying a message to the user
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="CU-ContactUs-container">
      <h1 className="CU-header-title">iSpeakWell</h1>
      <h5 className="CU-tagline">
        Become a member of the iSpeakWell crew.
      </h5>
      <img
        src={crewImages[currentIndex]}
        alt="Overlay"
        style={{
          position: "relative",
          width: "55%",
          opacity: "0.80",
        }}
      />
      <p>Please let us know your thoughts.</p>
      {emailSent ? (
        <div>
          <hr className="CU-SubmittedMessage"/>
          <h3 className="CU-SubmittedMessage">Your email has been submitted.  Thanks for contacting us.  We'll connect with you shortly.</h3>
          <hr />
        </div>
      ) : (
        <form className="CU-contact-form" onSubmit={handleSubmit}>
          <label htmlFor="name">Name:</label>
          <input type="text" id="name" name="name" required />

          <label htmlFor="email">Email:</label>
          <input type="email" id="email" name="email" required />

          <label htmlFor="message">Message:</label>
          <textarea id="message" name="message" required></textarea>
          {isLoading
            ? <Spinner />
            : <button type="submit">Send</button>
          }

        </form>
      )}
      <div className="CU-links-section">
        <button className="CU-link-button" onClick={() => navigateTo("/about")}>
          About
        </button>
        <button
          className="CU-link-button"
          onClick={() => navigateTo("/careers")}
        >
          Careers
        </button>
        <button
          className="CU-link-button"
          onClick={() => navigateTo("/tokens")}
        >
          Tokens
        </button>
        <button
          className="CU-link-button"
          onClick={() => navigateTo("/contactus")}
        >
          Contact Us
        </button>
        <button className="CU-link-button" onClick={() => navigateTo("/login")}>
          Login
        </button>
      </div>
    </div>
  );
}
export default ContactUs;
